<h1 *ngIf="!showSmallTitle" class="freshpass-title pt-1 pb-3">{{programDisplayData?.subscribeData?.freshPass}}</h1>
<h2 *ngIf="showSmallTitle" class="freshpass-title pt-1 pb-3">{{programDisplayData?.subscribeData?.freshPass}}</h2>
